import { BUDDIES } from './Base';

export const onGetApprovedBuddiesRequest = (params = {}, cb) => ({ params, cb, type: BUDDIES.GET_APPROVED_BUDDIES_REQUEST });
export const onGetApprovedBuddiesSuccess = (payload = {}) => ({ payload, type: BUDDIES.GET_APPROVED_BUDDIES_SUCCESS });
export const onGetApprovedBuddiesFailure = (error = {}) => ({ error, type: BUDDIES.GET_APPROVED_BUDDIES_FAILURE });
